module.exports = __webpack_public_path__ + "img/Alexa Skill.86c69153.png";